/* eslint-disable react/prop-types */
import Badge from 'components/base/Badge';
import FeatherIcon from 'feather-icons-react';
import PopoverTrigger from './PopoverTrigger';
import Icon from 'components/icon';
import styled from '@emotion/styled';

const CommentContainer = styled('p')`
  overflow: hidden;
  /* display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical; */
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 250px;
`;

const flagMap = {
  1: 'Change',
  2: 'Rejected'
};

const StatusBadge = ({
  badgeDetail,
  getStatus,
  status,
  className,
  flag,
  lastComment,
  variant = 'phoenix'
}) => {
  const badge = badgeDetail ?? getStatus(status);
  const flagBadge = flag !== '0' && !!flag ? getStatus(flagMap[flag]) : null;
  return (
    <>
      <Badge
        bg={badge.color}
        variant={variant}
        iconPosition="end"
        className={`fs-10 font-outfit ${className}`}
        icon={
          badge.icon ? (
            <FeatherIcon icon={badge.icon} size={12.8} className="ms-1" />
          ) : (
            ''
          )
        }
      >
        {badge.label || status}
      </Badge>
      <br />
      {flagBadge && (
        <Badge
          bg={flagBadge.color}
          variant={variant}
          iconPosition="end"
          className={`fs-10 font-outfit ${className}`}
          icon={
            flagBadge.icon ? (
              <FeatherIcon icon={flagBadge.icon} size={12.8} className="ms-1" />
            ) : (
              ''
            )
          }
        >
          {flagBadge.label || status}
        </Badge>
      )}
      {flag === '2' && lastComment && (
        <PopoverTrigger
          trigger={['hover', 'click']}
          variant={'secondary'}
          title={'Last Comment'}
          message={<div>{lastComment}</div>}
          className="w-max-content"
        >
          <CommentContainer className="m-0 mt-1 border-3 p-0 fs-10 text-warning  gap-1">
            <Icon icon={'fluent:comment-24-regular'} fontSize="14px" />
            <span className="ms-1">{lastComment}</span>
          </CommentContainer>
        </PopoverTrigger>
      )}
    </>
  );
};

export default StatusBadge;
